import React from 'react';
import PropTypes from 'prop-types';
import CheckMark from './checkmark';
import Globe from './globe';
import Phone from './phone';
import RightArrow from './rightArrow';
import LeftArrow from './leftArrow';
import DownArrow from './downArrow';
import UpArrow from './upArrow';
import Circle from './circle';
import Facebook from './facebook';

export class SVGIcon extends React.Component {
  getViewBox = name => {
    switch (name) {
      case 'facebook':
        return '0 0 12 12';
      case 'globe':
        return '0 0 16 16';
      default:
        return '0 0 24 24';
    }
  };

  getPath = (name, fill) => {
    switch (name) {
      case 'rightArrow':
        return RightArrow(fill);
      case 'leftArrow':
        return LeftArrow(fill);
      case 'downArrow':
        return DownArrow(fill);
      case 'upArrow':
        return UpArrow(fill);
      case 'checkmark':
        return CheckMark(fill);
      case 'circle':
        return Circle(fill);
      case 'facebook':
        return Facebook(fill);
      case 'globe':
        return Globe(fill);
      case 'phone':
        return Phone(fill);
      default:
        return <path />;
    }
  };

  render() {
    const {
      name = '',
      fill = '#000',
      size = '32px',
      transform = '',
      style,
    } = this.props;

    return (
      <svg
        className={name}
        height={size}
        width={size}
        style={style}
        transform={transform}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={this.getViewBox(name)}
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        {this.getPath(name, fill)}
      </svg>
    );
  }
}

SVGIcon.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.object,
  fill: PropTypes.string,
  size: PropTypes.string,
};

export default SVGIcon;



// WEBPACK FOOTER //
// ./src/assets/svg-icons/icons.js